import { render, staticRenderFns } from "./Spaces.vue?vue&type=template&id=629ba3d2&scoped=true"
import script from "./Spaces.vue?vue&type=script&lang=js"
export * from "./Spaces.vue?vue&type=script&lang=js"
import style0 from "./Spaces.vue?vue&type=style&index=0&id=629ba3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629ba3d2",
  null
  
)

export default component.exports